<template>
    <div class="nodes-tree">
        <div v-if="nodes.length" class="nodes-tree__wrapper">
            <NodesTreeItem
                v-for="(node, idx) in nodes"
                :key="node.id"
                ref="nodesTreeItem"
                :node="node"
                :root-idx="node.depends_on.length ? rootIdx : idx"
                :allowed-actions="allowedActions"
                @addNode="addNode"
                @updateNode="updateNode"
                @deleteNode="deleteNode"
                @updateNodeTree="updateNodeTree"
                @deleteRelations="deleteRelations"
            />
        </div>
        <button
            v-if="level === 0"
            class="button button--icon nodes-tree__add"
            @click.prevent="addNode"
        >
            <IconPlus />
        </button>
    </div>
</template>

<script>
import NodesTreeItem from './NodesTreeItem';
import { IconPlus } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'NodesTree',
    components: {
        NodesTreeItem,
        IconPlus,
    },
    props: {
        nodes: {
            type: Array,
            default: () => [],
        },
        rootIdx: {
            type: Number,
            default: 0,
        },
        allowedActions: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        level() {
            const { level = 0 } = this.nodes[0] || {};
            return level;
        },
    },
    methods: {
        addNode(event) {
            this.$emit('addNode', event);
        },
        deleteNode(event) {
            this.$emit('deleteNode', event);
        },
        async updateNode(event) {
            await this.$nextTick();
            this.$emit('updateNode', event);
        },
        updateNodeTree(event) {
            this.$emit('updateNodeTree', event);
        },
        deleteRelations(event) {
            console.log('deleteRelations', event);
            this.$emit('deleteRelations', event);
        },
        refreshTree() {
            // this.$refs.nodesTreeItem.forEach(res => res.drawRelations());
        },
    },
};
</script>
